import { createFileRoute } from '@tanstack/react-router'

import CategoryDetailPage from '@/views/categories/category.id.page'

export const Route = createFileRoute('/_layout/stores/$id')({
  component: CategoryDetailPage,
})
